import { View, Text } from "react-native";
import { ImageIcon } from "lucide-react-native";
import { EMBER } from "../../../onboarding/theme";
import { StatusBadge } from "@louise/moon-ui";
import { semanticColors } from "@louise/theme/tokens";

type Props = {
  label: string;
  description?: string;
};

export default function DiagramPlaceholder({ label, description }: Props) {
  return (
    <View
      style={{
        borderWidth: 1.5,
        borderStyle: "dashed",
        borderColor: semanticColors.border.subtle,
        borderRadius: 16,
        backgroundColor: semanticColors.surface.muted,
        padding: 24,
        alignItems: "center",
        justifyContent: "center",
        minHeight: 140,
        marginTop: 12,
        gap: 10,
      }}
    >
      <ImageIcon size={24} color={EMBER.colors.textFaint} strokeWidth={1.5} />
      <Text
        className="font-dm-sans"
        style={{
          fontSize: 13,
          fontWeight: "600",
          color: EMBER.colors.textMid,
          textAlign: "center",
        }}
      >
        {label}
      </Text>
      {description && (
        <Text
          className="font-dm-sans"
          style={{
            fontSize: 12,
            color: EMBER.colors.textFaint,
            textAlign: "center",
          }}
        >
          {description}
        </Text>
      )}
      <View style={{ marginTop: 4 }}>
        <StatusBadge type="coming-soon" />
      </View>
    </View>
  );
}
